/**
 * Theme Header View
 */
class ThemeHeaderView {

	constructor(presenter, sectionId) {

		this.parent = $("#shopify-section-" + sectionId);
		this.header = $("header.mon-header");
		this.nav = this.parent.find("nav").first();
		this.clock = $("#mon-header-clock");
		this.boutiquesOffcanvas = $("#mon-header-boutiques-offcanvas");
		this.watchesOffcanvas = $("#mon-header-watches-offcanvas");
		this.watchesOffcanvasImageUrl = $("a.mon-header-watches-offcanvas-image-url");
		this.watchesOffcanvasImage = $("#mon-header-watches-offcanvas-image");
		this.jewelleryOffcanvas = $("#mon-header-jewellery-offcanvas");
		this.jewelleryOffcanvasImageUrl = $("a.mon-header-jewellery-offcanvas-image-url");
		this.jewelleryOffcanvasImage = $("#mon-header-jewellery-offcanvas-image");
		this.accessoriesOffcanvas = $("#mon-header-accessories-offcanvas");
		this.accessoriesOffcanvasImageUrl = $("a.mon-header-accessories-offcanvas-image-url");
		this.accessoriesOffcanvasImage = $("#mon-header-accessories-offcanvas-image");
		this.searchOffcanvas = $("#mon-header-search-offcanvas");
		this.searchOffcanvasQuery = $("#mon-header-search-offcanvas-query");
		this.searchOffcanvasBody = this.searchOffcanvas.find(".offcanvas-body").first();
		this.searchOffcanvasLink = $("#mon-header-search-body-link > a").first();
		this.searchOffcanvasProducts = this.searchOffcanvas.find(".mon-header-search-body-products").first();
		this.searchOffcanvasProductsTemplate = $("#mon-header-search-body-products-template");
		this.searchOffcanvasPages = this.searchOffcanvas.find(".mon-header-search-body-pages").first();
		this.searchOffcanvasPageTemplate = $("#mon-header-search-body-page-template");
		this.searchOffcanvasCollections = this.searchOffcanvas.find(".mon-header-search-body-collections").first();
		this.searchOffcanvasCollectionTemplate = $("#mon-header-search-body-collection-template");
		this.cartLink = $("#mon-header-cart-link");
		this.navWishlist = this.parent.find(".mon-nav-wishlist");
		this.lastHeight = null;
		this.presenter = presenter;

		/*
		 * Listeners
		 */

		this.searchOffcanvas.on("shown.bs.offcanvas", $.proxy(function(_event) {
			// make sure the search input gains focus
			this.searchOffcanvasQuery.focus();
		}, this));

		this.searchOffcanvasQuery.on("input", $.proxy(function(_event) {
			// get the route and the query from the view, then request the results are returned
			const route = this.searchOffcanvasQuery.attr("data-route");
			const query = this.searchOffcanvasQuery.val();
			if (query != null && query.trim().length > 3) { this.presenter.retrieveQuery(route, query); }
		}, this));

		this.watchesOffcanvasImageUrl.on("mouseenter", $.proxy(function(event) {
			const imageUrl = $(event.currentTarget).attr("data-image-url");
			this.watchesOffcanvasImage.attr("src", imageUrl);
			this.watchesOffcanvasImage.css("opacity", "1");
		}, this));

		this.watchesOffcanvasImageUrl.on("mouseleave", $.proxy(function(event) {
			this.watchesOffcanvasImage.css("opacity", "0");
		}, this));

		this.jewelleryOffcanvasImageUrl.on("mouseenter", $.proxy(function(event) {
			const imageUrl = $(event.currentTarget).attr("data-image-url");
			this.jewelleryOffcanvasImage.attr("src", imageUrl);
			this.jewelleryOffcanvasImage.css("opacity", "1");
		}, this));

		this.jewelleryOffcanvasImageUrl.on("mouseleave", $.proxy(function(event) {
			this.jewelleryOffcanvasImage.css("opacity", "0");
		}, this));

		this.accessoriesOffcanvasImageUrl.on("mouseenter", $.proxy(function(event) {
			const imageUrl = $(event.currentTarget).attr("data-image-url");
			this.accessoriesOffcanvasImage.attr("src", imageUrl);
			this.accessoriesOffcanvasImage.css("opacity", "1");
		}, this));

		this.accessoriesOffcanvasImageUrl.on("mouseleave", $.proxy(function(event) {
			this.accessoriesOffcanvasImage.css("opacity", "0");
		}, this));

		const observer = new ResizeObserver($.proxy(function(_entries) {
			const height = this.nav.css("height");
			if (this.lastHeight == null || this.lastHeight != height) {
				// set the padding for the header-related elements
				this.lastHeight = height;
				this.header.css("padding-bottom", this.lastHeight);
				this.boutiquesOffcanvas.css("padding-top", this.lastHeight);
				this.watchesOffcanvas.css("padding-top", this.lastHeight);
				this.jewelleryOffcanvas.css("padding-top", this.lastHeight);
				this.accessoriesOffcanvas.css("padding-top", this.lastHeight);
				this.searchOffcanvas.css("padding-top", this.lastHeight);
				// notify listeners the last height has changed
				this.presenter.lastHeightChanged(this.lastHeight);
			}
		}, this));
		observer.observe(this.nav.get(0));

		/*
		 * Initialisation
		 */ 

		const moonPhase = new ThemeHeaderMoonPhase();
		$("#" + moonPhase.getPhase()).removeClass("d-none").addClass("d-flex");

		const showTime = new ThemeHeaderShowTime(this.clock);
		showTime.start();

	}

	/*
	 * Actions
	 */

	showSearchOffcanvasBody(show) {
		
		// get the collapse element and set its state
		const collapse = bootstrap.Collapse.getOrCreateInstance(this.searchOffcanvasBody.get(0));
		if (show == true) {
			collapse.show();
		}
		else {
			collapse.hide();
		}

	}

	addQueryProduct(product) {

		//  get the products template and append this product to it
		const template = this.searchOffcanvasProductsTemplate.clone();
		template.removeAttr("id");
		template.removeClass("d-none");
		template.append(product);

		// insert this product element before the pad element
		const pad = this.searchOffcanvasProducts.find(".mon-products-pad").first();
		pad.before(template);

	}

	setQueryPages(pages) {
		
		// iterate over the pages, and setup and append an element from the page template
		for (const page of pages) {
			const template = this.searchOffcanvasPageTemplate.clone();
			template.removeAttr("id");
			template.removeClass("d-none");
			const link = template.find("a").first();
			link.attr("href", page.url);
			link.text(page.title);
			this.searchOffcanvasPages.append(template);
		}

	}

	setQueryCollections(collections) {
		
		// iterate over the collections, and setup and append an element from the collection template
		for (const collection of collections) {
			const template = this.searchOffcanvasCollectionTemplate.clone();
			template.removeAttr("id");
			template.removeClass("d-none");
			const link = template.find("a").first();
			link.attr("href", collection.url);
			link.text(collection.title);
			this.searchOffcanvasCollections.append(template);
		}

	}

	clearQueryResults() {
		
		// we need to make sure we keep some of the previous products invisible to maintain the height of the search box
		const pad = this.searchOffcanvasProducts.find(".mon-products-pad").first();
		this.searchOffcanvasProducts.children(":not(.mon-products-pad)").each(function() {
			
			// we remove any children that are currently invisible, and make any showing invisible
			const remove = new Array();
			const child = $(this);
			if (child.hasClass("invisible") == true) {
				remove.push(child);
			}
			else {
				child.addClass("invisible");
				pad.after(child);
			}

			// only remove the former invisible children after the new elements have been added
			for (const element of remove) { element.remove(); }

		});
		
		// empty the pages and collections containers
		this.searchOffcanvasPages.empty();
		this.searchOffcanvasCollections.empty();

	}

	/*
	 * Getters and Setters
	 */

	setSearchLink(link) {
		this.searchOffcanvasLink.attr("href", link);
	}

	setCartCount(count) {
		const icons = this.cartLink.find("i.bi");
		const span = this.cartLink.find("span").first();
		if (count > 0) {
			icons.first().removeClass("d-inline").addClass("d-none");
			icons.last().removeClass("d-none").addClass("d-inline");
			span.text(count);
		}
		else {
			icons.first().removeClass("d-none").addClass("d-inline");
			icons.last().removeClass("d-inline").addClass("d-none");
			span.text("");
		}
	}

	setLocalStorageAvailable() {
		this.navWishlist.removeClass("d-none");
	}
	
}

// see: https://github.com/mourner/suncalc
class ThemeHeaderMoonPhase {

	constructor(date) {
		this.date = null;
		if (date == null) {
			this.date = new Date();
		}
		else {
			this.date = date;
		}
	}

	getPhase() {
		const moon = SunCalc.getMoonIllumination(this.date);
		const phase = moon.phase;
		if (phase < 0.0625) { return "mon-moon-1-new"; }
		if (phase < 0.1875) { return "mon-moon-2-waxing-crescent"; }
		if (phase < 0.3125) { return "mon-moon-3-first-quarter"; }
		if (phase < 0.4375) { return "mon-moon-4-waxing-gibbous"; }
		if (phase < 0.5625) { return "mon-moon-5-full"; }
		if (phase < 0.6825) { return "mon-moon-6-waning-gibbous"; }
		if (phase < 0.8125) { return "mon-moon-7-last-quarter"; }
		if (phase < 0.9375) { return "mon-moon-8-waning-crescent"; }
		return "mon-moon-1-new";
	}

}

class ThemeHeaderShowTime {

	constructor(clock) {
		this.clock = clock;
		this.showTime = null;
	}

	start() {

		// we only start the process once
		if (this.showTime != null) { return; }
		
		// setup the function that periodically sets the time
		this.showTime = $.proxy(function() {
			
			// setup the hour and minute
			const date = new Date();
			var h = date.getHours(); 		// 0 - 23
			if (h == 0) { h = 12; }
			if (h > 12) { h = h - 12; }
			if (h < 10) { h = "0" + h; }
			var m = date.getMinutes();		// 0 - 59
			if (m < 10) { m = "0" + m; }
			
			// set the time and periodically refresh it every second
			const time = h + ":" + m;
			this.clock.text(time);
			setTimeout(this.showTime, 100);

		}, this);

		// start showing the time
		this.showTime();

	}

}